import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { SyncClient } from './SyncClient';
import { findSyncedBlockParent } from './utils';
export var syncedBlockPluginKey = new PluginKey('syncedBlockPlugin');

// eslint-disable-next-line @typescript-eslint/no-empty-object-type

export var createPlugin = function createPlugin() {
  var syncClient = new SyncClient();
  return new SafePlugin({
    key: syncedBlockPluginKey,
    state: {
      init: function init() {
        return {};
      },
      apply: function apply(tr, currentPluginState) {
        if (tr.docChanged) {
          var $pos = tr.selection.$from;
          var syncedBlockParent = findSyncedBlockParent($pos);
          if (syncedBlockParent) {
            var node = syncedBlockParent.node,
              attributes = syncedBlockParent.attributes;
            var _attributes$parameter = attributes.parameters,
              sourceDocumentAri = _attributes$parameter.sourceDocumentAri,
              contentAri = _attributes$parameter.contentAri,
              contentPropertyKey = _attributes$parameter.contentPropertyKey;
            syncClient.syncContent({
              sourceDocumentAri: sourceDocumentAri,
              contentAri: contentAri,
              contentPropertyKey: contentPropertyKey,
              node: node
            });
          }
        }
        var meta = tr.getMeta(syncedBlockPluginKey);
        if (meta) {
          return meta;
        }
        return currentPluginState;
      }
    }
  });
};